import { render } from "./InputDemo.vue?vue&type=template&id=46682221"
import script from "./InputDemo.vue?vue&type=script&lang=js"
export * from "./InputDemo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/chatbot_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__